import React from 'react';

import QuotaArcorSedes  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/QuotaSedes/List.js';

export default function () {
  return <QuotaArcorSedes  />;
}
